<template>
  <div class="shop-management">
    <el-row class="shop-infomation" v-if="isSupplier">
      <BusinessCardTop
        :cardDetail="cardDetail"
        :cooperationDetail="cooperationDetail"
        :identity="identity"
      />
      <!-- 数据统计 -->
      <el-col class="item-flex">
        <div class="distributor-num">
          <!-- 分销商：<span class="num">0</span> -->
          <el-tooltip :content="forbidInvite ? '当前订购ERP版本不支持邀请分销商，请联系客服/实施/销售升级系统版本' : ''" placement="top">
            <el-button type="link" @click="handleInviteDistribute" :disabled="forbidInvite">邀请分销商</el-button>
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
    <!--供销商 公告，合作说明 -->
    <el-row class="notice-wrapper" v-if="isSupplier">
      <el-col>
        <div class="notice-header">
          <img src="@/assets/images/announcement.png" alt="" srcset="" width="70" >
          <el-divider direction="vertical"></el-divider>
          <div class="notice-content">
            <div :class="{'marquee': needScroll, 'text-999': !cardDetail.announcement}">{{cardDetail.announcement || '暂无'}}</div>
          </div>
          <el-button type="text" @click="handleEditNotice">立即编辑</el-button>
        </div>
        <el-divider></el-divider>
        <div class="notice-header">
          <img src="@/assets/images/cooperation.png" alt="" srcset="" width="70" >
          <el-divider direction="vertical"></el-divider>
          <div class="notice-content">
            <div :class="{'marquee': needScroll2, 'text-999': !cardDetail.collaborationDesc}">{{cardDetail.collaborationDesc || '暂无'}}</div>
          </div>
          <el-button type="text" @click="editCard">立即编辑</el-button>
        </div>
      </el-col>
    </el-row> 
    

    <!-- 未登录分享 -->
    <div @click="stopProp" class="flex flex-1" v-if="isUnLoginShare" style="margin:10px 0 0 0">
      <el-row>
        <BusinessCardTop :identity="identity" :showMin="false" :cardDetail="cardDetail" :cooperationDetail="cooperationDetail" />
      </el-row>
      <div class="mgr28">
        <el-button type="primary" @click="handleLgin">申请合作</el-button>
        <span class="ftsz12 text-999">（合作后可查看更多专享商品）</span>
      </div>
    </div>
    <!-- 非供销商端、非分销商端的公告（未登录分享等） -->
    <h2 style="display: inline-block; margin: 0px 0px 8px 0px;" v-if="(cardDetail.announcement || cardDetail.collaborationDesc) && !isSupplier && !isDistributor && !isDetail && !isShare">{{cardDetail.companyName || '小店商家名'}}</h2>
    <el-row class="notice-wrapper mb-10" v-if="(cardDetail.announcement || cardDetail.collaborationDesc) && !isSupplier && !isDistributor && !isDetail">
      <div class="notice-header" v-if="cardDetail.announcement">
        <img src="@/assets/images/announcement_dis.png" alt="" srcset="" width="70" >
        <el-divider direction="vertical"></el-divider>
        <div class="notice-content">
          <div :class="{'marquee': needScroll, 'text-999': !cardDetail.announcement}">{{cardDetail.announcement || '暂无'}}</div>
        </div>
      </div>
      <el-divider v-if="cardDetail.announcement && cardDetail.collaborationDesc"></el-divider>
      <div class="notice-header" v-if="cardDetail.collaborationDesc">
        <img src="@/assets/images/cooperation_dis.png" alt="" srcset="" width="70" >
        <el-divider direction="vertical"></el-divider>
        <div class="notice-content">
          <div :class="{'marquee': needScroll2, 'text-999': !cardDetail.collaborationDesc}">{{cardDetail.collaborationDesc || '暂无'}}</div>
        </div>
      </div>
    </el-row>

    <!-- 自定义折叠面板 - 分销商端 -->
    <div v-if="isDistributor" class="custom-collapse distributor-collapse" :class="{ 'is-expanded': isExpanded }">
      <div class="collapse-header" @click="toggleCollapse">
        <div class="header-left" v-show="isExpanded">
          <span class="header-main-label">主营类目：</span>
          <el-popover placement="top-start" trigger="hover" width="800">
            <span>{{majorCategoryName || '-'}}</span>
            <span slot="reference" class="header-main-text" @click.stop>{{majorCategoryName || '-'}}</span>
          </el-popover>
        </div>
        <el-button type="link" class="collapse-toggle" @click.stop="toggleCollapse">
          {{ isExpanded ? '收起' : '展开' }}
          <i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
      </div>
      <div class="collapse-content-wrapper">
        <div class="collapse-content">
          <div class="distributor-view">
            <div class="d-main-layout">
              <!-- 左侧信息区 -->
              <div class="d-left-info">
                <div class="d-info-row">
                  <span class="d-label">主营平台：</span>
                  <span v-if="hideMainPlatform" class="d-text">{{ platformUnseeText }}</span>
                  <span v-else class="d-platform-icons">
                    <el-avatar v-for="source in cardDetail.majorPlatform" :key="source.k" shape="square" size="small" :src="PLATFORM_ICONS_MAP[source.k]" />
                    <span v-if="!cardDetail.majorPlatform || !cardDetail.majorPlatform.length"> - </span>
                  </span>
                </div>
                <div class="d-info-row">
                  <span class="d-label">分销平台：</span>
                  <span v-if="hideMainPlatform" class="d-text">{{ platformUnseeText }}</span>
                  <span v-else class="d-platform-icons">
                    <el-avatar v-for="dis in cardDetail.distributionPlatform" :key="dis" shape="square" size="small" :src="PLATFORM_ICONS_MAP[dis]" />
                    <span v-if="!cardDetail.distributionPlatform || !cardDetail.distributionPlatform.length"> - </span>
                  </span>
                </div>
                <div class="d-info-row">
                  <span class="d-label">合作意向：</span>
                  <span class="d-text">供货</span>
                </div>
                <!-- 服务能力 -->
                <div class="d-stats-row">
                  <span class="d-stats-label">服务能力：</span>
                  <div class="d-stats-items">
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.deliveryTime)">
                      <span class="d-stat-value">{{ cooperationDetail.deliveryTime }}</span>
                      <span class="d-stat-sub">发货时效</span>
                    </div>
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.distributorCount)">
                      <span class="d-stat-value">{{ cooperationDetail.distributorCount }}</span>
                      <span class="d-stat-sub">分销商数</span>
                    </div>
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.deliveryItemCount30D)">
                      <span class="d-stat-value">{{ cooperationDetail.deliveryItemCount30D }}</span>
                      <span class="d-stat-sub">月发货均数</span>
                    </div>
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.deliverRate48H)">
                      <span class="d-stat-value">{{ cooperationDetail.deliverRate48H }}%</span>
                      <span class="d-stat-sub">48h发货率</span>
                    </div>
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.deliverRate24H)">
                      <span class="d-stat-value">{{ cooperationDetail.deliverRate24H }}%</span>
                      <span class="d-stat-sub">24h支付揽收率</span>
                    </div>
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.afterSalesRate)">
                      <span class="d-stat-value">{{ cooperationDetail.afterSalesRate }}%</span>
                      <span class="d-stat-sub">售后率</span>
                    </div>
                  </div>
                </div>
                <!-- 商品能力 -->
                <div class="d-stats-row">
                  <span class="d-stats-label">商品能力：</span>
                  <div class="d-stats-items">
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.distributeGoodCount)">
                      <span class="d-stat-value">{{ cooperationDetail.distributeGoodCount }}</span>
                      <span class="d-stat-sub">可分销商品</span>
                    </div>
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.monthlyGoodUpdate)">
                      <span class="d-stat-value">{{ cooperationDetail.monthlyGoodUpdate }}</span>
                      <span class="d-stat-sub">月上新数</span>
                    </div>
                    <div class="d-stat-item" v-if="JudgeEmptyKey(cooperationDetail.avgSupplyPrice)">
                      <span class="d-stat-value">{{ cooperationDetail.avgSupplyPrice }}元</span>
                      <span class="d-stat-sub">平均供货价</span>
                    </div>
                  </div>
                </div>
                <div class="d-info-row" v-if="cardDetail.refundAddress">
                  <span class="d-label">退款地址：</span>
                  <span class="d-text">{{ cardDetail.refundAddress }}</span>
                </div>
                <div class="d-info-row">
                  <span class="d-label">商家简介：</span>
                  <span class="d-text">{{ cardDetail.summary || '-' }}</span>
                </div>
                <div class="d-info-row" v-if="cardDetail.receiveAddress">
                  <span class="d-label">退货地址：</span>
                  <span class="d-text">{{ cardDetail.receiveAddress }}</span>
                </div>
              </div>
              <!-- 右侧视频/图片轮播 -->
              <div class="d-right-gallery" v-if="(cardDetail.video && cardDetail.video.length) || (cardDetail.picture && cardDetail.picture.length)">
                <el-carousel :interval="5000" arrow="always" :autoplay="false" ref="carousel" height="280px">
                  <template v-if="cardDetail.video && cardDetail.video.length">
                    <el-carousel-item v-for="vid in cardDetail.video" :key="vid.originUrl">
                      <video controls style="height: 100%; width: 100%;">
                        <source type="video/mp4" :src="vid.originUrl">
                      </video>
                    </el-carousel-item>
                  </template>
                  <template v-if="cardDetail.picture && cardDetail.picture.length">
                    <el-carousel-item v-for="pic in cardDetail.picture" :key="pic">
                      <el-image :src="pic" fit="cover" style="height: 100%; width: 100%;" />
                    </el-carousel-item>
                  </template>
                </el-carousel>
                <div class="slider-detail-infomation">
                  <template v-if="cardDetail.video && cardDetail.video.length">
                    <div class="slider-item" v-for="(vid, index) in cardDetail.video" :key="vid.originUrl" @mouseenter="setActiveItem(index)">
                      <video controls>
                        <source type="video/mp4" :src="vid.originUrl">
                      </video>
                    </div>
                  </template>
                  <template v-if="cardDetail.picture && cardDetail.picture.length">
                    <div class="slider-item" v-for="(pic, index) in cardDetail.picture" :key="pic" @click="setActiveItem((cardDetail.video ? cardDetail.video.length : 0) + index)">
                      <el-image :src="pic"></el-image>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 供销商端 / 分销商名片 / 未登录 保持原有布局 -->
    <el-collapse v-else :value="collapseValues" class="business-collapse" @change="handleChangeCollapse">
      <el-collapse-item name="card" :disabled="isDistributorMyCard">
        <template slot="title" v-if="isUnLoginShare">
          <span class="pdr12 text-666" style="position: absolute;right: 14px;">{{collapseValues.includes('card') ? '收起' : '展开'}}</span>
        </template>

        <template slot="title" v-if="isSupplier">
          <h3>供销商名片</h3>
          <el-button type="link" @click.stop="editCard">
            编辑名片
          </el-button>
        </template>
        <template slot="title" v-if="isDistributorMyCard">
          <h3 class="mg0 mgr4">我的分销名片</h3>
          <el-tooltip popper-width="300px" effect="light" placement="right">
            <div slot="content">
              <div class="text-999">
                <div>该名片用于供销商寻分销合作，或分销商向供销商申请合作时，展示自己的找货需求、销售能力。</div>
              </div>
            </div>
            <i class="el-icon-bangzhuzhongxin icon-tip"></i>
          </el-tooltip>
          <el-button type="link" @click.stop="editCard">
            编辑名片
          </el-button>
          <div>
            <el-button
              type="primary"
              @click="handleInviteSuppliers"
            >邀请供销商</el-button>
          </div>
        </template>
        <div class="dis-flex">
          <div class="flex-1 pdr10 mw0">
            <el-card style="height: 100%">
              <div class="title">
                公司信息
              </div>
              <div class="company-infomation"  style="width:100%">
                <div class="company-item"><span class="label-info">公司名称：</span><span class="num">{{cardDetail.companyName || '小店商家名'}}</span></div>
                <div class="company-item" v-if="isSupplier">
                  <span class="label-info">联系方式：</span>
                  <span v-if="cardDetail.phone">手机 {{cardDetail.phone}} <el-divider direction="vertical"></el-divider> 微信 {{cardDetail.wx}}</span>
                  <span v-else> - </span>
                </div>
                <div class="company-item main-platfrom dis-flex">
                  <span class="label-info">主营类目：</span>
                  <el-popover
                      placement="top-start"
                      trigger="hover"
                      class="m-popover flex-1 mw0"
                      width="800"
                  >
                    <span>{{majorCategoryName || '-'}}</span>
                    <div slot="reference">
                      <span class="text-ellipsis">{{majorCategoryName || '-'}}</span>
                    </div>
                  </el-popover>
                </div>
                <div class="company-item main-platfrom" style="overflow: hidden;"><span class="label-info">主营平台：</span>
                  <span v-if="hideMainPlatform">{{ platformUnseeText }}</span>
                  <el-popover
                      v-else
                      placement="top-start"
                      trigger="hover"
                      width="800"
                  >
                    <div>
                      <span v-if="cardDetail.majorPlatform.length">
                        <el-avatar style="margin-right:10px" v-for="source in cardDetail.majorPlatform" :key="source.k" size="small" :src="PLATFORM_ICONS_MAP[source.k]"></el-avatar>
                      </span>
                      <span v-else> 暂无 </span>
                    </div>
                    <div slot="reference">
                      <span v-if="cardDetail.majorPlatform.length" class="text-ellipsis">
                        <el-avatar style="margin-right:10px" v-for="source in cardDetail.majorPlatform" :key="source.k" size="small" :src="PLATFORM_ICONS_MAP[source.k]"></el-avatar>
                      </span>
                      <span v-else> - </span>
                    </div>
                  </el-popover>
                </div>
                <div class="company-item main-platfrom" style="overflow: hidden;" v-if="!isDistributorMyCard"><span class="label-info">分销平台：</span>
                  <span v-if="hideMainPlatform">{{ platformUnseeText }}</span>
                  <el-popover
                      v-else
                      placement="top-start"
                      trigger="hover"
                      width="800"
                  >
                    <div>
                       <span v-if="cardDetail.distributionPlatform.length">
                        <el-avatar style="margin-right:10px" v-for="dis in cardDetail.distributionPlatform" :key="dis" size="small" :src="PLATFORM_ICONS_MAP[dis]"></el-avatar>
                        </span>
                      <span v-else> 暂无 </span>
                    </div>
                    <div slot="reference">
                       <span v-if="cardDetail.distributionPlatform.length" class="text-ellipsis">
                          <el-avatar style="margin-right:10px" v-for="dis in cardDetail.distributionPlatform" :key="dis" size="small" :src="PLATFORM_ICONS_MAP[dis]"></el-avatar>
                        </span>
                      <span v-else> - </span>
                    </div>
                  </el-popover>
                </div>
                <div class="company-item main-platfrom">
                  <span class="label-info">商家简介：</span>
                  <el-popover
                      placement="top-start"
                      trigger="hover"
                      class="m-popover"
                  >
                    <span>{{cardDetail.summary || '暂无'}}</span>
                    <div slot="reference">
                      <span class="text-ellipsis">{{cardDetail.summary || '-'}}</span>
                    </div>
                  </el-popover>
                </div>
                <div class="company-item" style="display:flex">
                  <span class="label-info" style="flex-shrink:0">商家实力：</span>
                  <div class="swiper-info">
                    <template  v-if="(cardDetail.video && cardDetail.video.length) || (cardDetail.picture && cardDetail.picture.length)">
                      <el-carousel :interval="5000" arrow="always" :autoplay="false" ref="carousel">
                        <template v-if="cardDetail.video && cardDetail.video.length">
                          <el-carousel-item v-for="vid in cardDetail.video" :key="vid.originUrl">
                            <video controls style="height: 100%;">
                              <source type="video/mp4" :src="vid.originUrl">
                            </video>
                          </el-carousel-item>
                        </template>
                        <template v-if="cardDetail.picture && cardDetail.picture.length">
                          <el-carousel-item v-for="pic in cardDetail.picture" :key="pic">
                            <el-image style="height: 100%;" :src="pic"></el-image>
                          </el-carousel-item>
                        </template>
                      </el-carousel>
                      <div class="slider-detail-infomation">
                        <template v-if="cardDetail.video && cardDetail.video.length">
                          <div class="slider-item" v-for="(vid, index) in cardDetail.video" :key="vid.originUrl"  @mouseenter="setActiveItem(index)">
                            <video controls>
                              <source type="video/mp4" :src="vid.originUrl">
                            </video>
                          </div>
                        </template>
                        <template v-if="cardDetail.picture && cardDetail.picture.length">
                          <div class="slider-item" v-for="(pic, index) in cardDetail.picture" :key="pic" @click="setActiveItem(cardDetail.video.length + index)">
                            <el-image :src="pic"></el-image>
                          </div>
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <div class="empty-status">
                        <el-image :src="empty"></el-image>
                        <div class="text">
                          <div v-if="isDistributorMyCard">上传公司视频及店铺图片等素材，让更多合作伙伴看到您的真实情况，提升合作成功率，增加更多收益！后续可通过【编辑名片】进行维护更新</div>
                          <div v-else>上传公司视频及仓储、展厅、档口图片等素材，让更多合作伙伴看到您的真实情况，提升合作成功率，增加更多收益！后续可通过【编辑名片】进行维护更新</div>
                          <i class="el-icon-upload"></i>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="flex-1 pdl10">
            <el-card style="height:100%">
              <div class="title">
                合作意向
              </div>
              <div class="company-item">
                <span class="label-info">合作意向：</span>
                <span class="num" v-if="isDistributorMyCard">找货</span>
                <span class="num" v-else>供货</span>
              </div>
              <div class="company-item dis-flex align-start" v-if="isDistributorMyCard">
                <span class="label-info">找货需求：</span>
                <div class="" v-if="findCategoryOptions.length <= 0">-</div>
                <div>{{findCategoryOptionsText}}</div>
              </div>
              <div class="company-item item-flex" v-if="!isDistributorMyCard">
                <span class="label-info">服务能力：</span>
                <div class="service-list">
                    <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.deliveryTime)">
                    <div>发货时效</div>
                    <div class="num">{{cooperationDetail.deliveryTime }}</div>
                  </div>
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.distributorCount)">
                    <div>分销商数</div>
                    <div class="num">{{cooperationDetail.distributorCount }}</div>
                  </div>
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.deliveryItemCount30D)">
                    <div>月均发货数</div>
                    <div class="num">{{cooperationDetail.deliveryItemCount30D }}</div>
                  </div>
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.deliverRate48H)">
                    <div>48h发货率</div>
                    <div class="num">{{ cooperationDetail.deliverRate48H }}%</div>
                  </div>
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.deliverRate24H)">
                    <div>24h支付揽收率</div>
                    <div class="num">{{ cooperationDetail.deliverRate24H }}%</div>
                  </div>
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.afterSalesRate)">
                    <div>售后率</div>
                    <div class="num">{{ cooperationDetail.afterSalesRate}}%</div>
                  </div>
                </div>
              </div>
              <div class="company-item item-flex" v-if="!isDistributorMyCard">
                <span class="label-info">商品能力：</span>
                <div class="service-list">
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.distributeGoodCount)">
                    <div>可分销商品</div>
                    <div class="num">{{ cooperationDetail.distributeGoodCount }}</div>
                  </div>
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.monthlyGoodUpdate)">
                    <div>月上新商品</div>
                    <div class="num">{{ cooperationDetail.monthlyGoodUpdate }}</div>
                  </div>
                  <div class="list-item" v-if="JudgeEmptyKey(cooperationDetail.avgSupplyPrice)">
                    <div>平均供货价</div>
                    <div class="num">{{cooperationDetail.avgSupplyPrice}}元</div>
                  </div>
                </div>
              </div>
              <div class="company-item item-flex">
                <span class="label-info">合作模式：</span>
                <div class="service-list">
                  <template v-if="cooperationDetail.cooperationMode.length">
                    <el-tag style="height:22px;line-height:22px" v-for="tag in cooperationDetail.cooperationMode" :key="tag" :type="tag == 1 ? 'success' : ''">{{cooperationMode_map[tag]}}</el-tag>
                  </template>
                  <template v-else>
                    <span>-</span>
                  </template>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <EditCard :identity="identity" @update="updateInfo" @update-mainList="fetch_getCategoryOptions" @contact-updated="onContactUpdated" :editCompanyForm="cardDetail" :editCooperationFrom="cooperationDetail" ref="editCardDialogs" />
    <InviteSuppliers
      :dialogVisible.sync="inviteSuppliersDialog"
    />
    <InviteDistribute
      ref="inviteDistribute"
    />
    <!-- 添加编辑公告弹框 -->
    <el-dialog
      title="编辑公告"
      :visible.sync="noticeDialogVisible"
      width="500px"
    >
      <el-form>
        <el-form-item>
          <el-input
            type="textarea"
            v-model="noticeForm.content"
            :maxlength="500"
            :rows="6"
            show-word-limit
            placeholder="请输入公告内容"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noticeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveNotice">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import empty from "@/assets/images/empty.jpg";
import EditCard from "@/pages/supplier/commodity/components/editCard";
import { PLATFORM_ICONS_MAP } from '@/dictionary/platforms.js'
import supplier_dictionary from '@/dictionary/supplier';
import {getCategoryOptions} from '@/servers/prod/center'
import BusinessCardTop from '@/pages/supplier/base/BusinessCardTop'
import { relationBind,editCompanyAnnouncement } from "@api/distributor";
import {get} from 'lodash';
import InviteSuppliers from "@/pages/distributor/supplier/mine/components/InviteSuppliersDialog";
import InviteDistribute from "@/pages/supplier/commodity/components/InviteDistribute";
import _ from 'lodash'

export default {
  props: {
    findCategoryOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    packUp: {
      type: Boolean,
      default: false
    },
    identity: {
      type: String,
      default: 'supplier'
    },
    updateInfo: {
      type: Function,
      default: ()=> {}
    },
    cardDetail: {
      type: Object,
      default: () => {
        return {
          companyName: '',
          majorCategory: '',
          wx: '',
          phone: '',
          vipMark: false,
          distributionPlatform: [],
          majorPlatform: [],
          picture: [],
          summary: ''
        }
      }
    },
    cooperationDetail: {
      type: Object,
      default: () => {
        return {
          cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
          deliveryTime: 1
        }
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      empty,
      PLATFORM_ICONS_MAP,
      cooperationMode_map: {
        1: '一件代发',
        2: '批量采购'
      },
      categoryOptions: [],
      collapseValues: this.packUp ? [''] : ['card'],
      inviteSuppliersDialog: false,
      noticeDialogVisible: false,
      noticeForm: {
        content: ''
      },
      needScroll: false,
      needScroll2: false,
      forbidInvite: false,
      isExpanded: !this.packUp
    }
  },
  watch: {
    cardDetail: {
      handler(newVal) {
        this.needScroll = newVal?.announcement?.length > 100
        this.needScroll2 = newVal?.collaborationDesc?.length > 100
      },
      deep: true
    }
  },
  computed: {
    findCategoryOptionsText() {
      return this.findCategoryOptions.map(elem => elem.name).join('/')
    },
    isSupplier() {
      // 供销商
      return this.identity === 'supplier'
    },
    isDistributor() {
      // 分销商
      return this.identity === 'distributor'
    },
    isDistributorMyCard() {
      // 分销商名片
      return this.identity === 'myDistributor'
    },
    isUnLoginShare() {
      // 未登录状态
      return this.identity === 'unLoginShare'
    },
    isDetail() {
      // 是否是详情页
      return location.pathname.startsWith('/distributor/supplier/productDetail')
    },
    isShare() {
      // 是否是小店页
      return location.pathname === '/distributor/supplier/info'
    },
    majorCategoryName() {
      // 分销商端查看供销商名片
      if (this.isDistributor) {
        let mainCategoryList = get(this.cardDetail, 'mainCategoryList', []) || [];
        return mainCategoryList.map(item => {
          return item.name
        }).join(',') || '-'
      }
      const baseCascaderCategory =  this.categoryOptions;
      return baseCascaderCategory.map(item => {
        return item.name
      }).join(',')
    },
    platformUnseeText() {
      return supplier_dictionary.PLATFORM_UNSEE_TEXT;
    },
    hideMainPlatform() {
      return this.isDistributor && (this.cardDetail.showDistributor === 0);
    },
  },
  components: {
    EditCard,
    BusinessCardTop,
    InviteSuppliers,
    InviteDistribute
  },
  created() {
    // this.$store.dispatch("getCategory")
    this.fetch_getCategoryOptions();

    // 获取供销商版本，若是快麦速享版或者畅享版，则隐藏邀请分销商按钮
    let purchaseVersion = this.$store.getters.userInfo.purchaseVersion;
    // 这个用户是速享版或畅享版，但如果是在白名单内，则可以邀请
    let featureCodes = this.$store.getters.featureCodes || [];
    let dmsSupplierCreated = featureCodes.includes('dmsSupplierCreated');

    if((purchaseVersion == 7 || purchaseVersion == 8) && !dmsSupplierCreated){
      this.forbidInvite = true;
    }
  },
  methods: {
    handleEditNotice() {
      this.noticeForm.content = this.cardDetail.announcement;
      this.noticeDialogVisible = true;
    },
    async handleSaveNotice() {
      let userInfo = this.$store.getters.userInfo;
      let res = await editCompanyAnnouncement({
        announcement: this.noticeForm.content,
        name: userInfo.companyName
      })
      if (res.result === 1) {
        this.$message.success('保存成功');
        this.cardDetail.announcement = this.noticeForm.content;
      }
      this.noticeDialogVisible = false;
    },
    handleEditCooperation() {
      // this.cooperationDialogVisible = true;
    },
    onContactUpdated(contactData) {
      if (contactData.wx !== undefined) this.$set(this.cardDetail, 'wx', contactData.wx);
      if (contactData.wxCode !== undefined) this.$set(this.cardDetail, 'wxCode', contactData.wxCode);
      if (contactData.phone !== undefined) this.$set(this.cardDetail, 'phone', contactData.phone);
    },
    setActiveItem(index) {
      this.$refs.carousel.setActiveItem(index)
    },
    editCard() {
      this.$refs.editCardDialogs.method_open(this.cardDetail,this.cooperationDetail)
    },
    async fetch_getCategoryOptions() {
      const options = await getCategoryOptions();
      this.categoryOptions = options && options.length ? options : [];
    },
    stopProp(e) {
      e.stopPropagation()
    },
    toggleCollapse() {
      this.isExpanded = !this.isExpanded;
      // 触发 DOM 更新后，collapse-content-wrapper 的高度会自动过渡
    },
    handleChangeCollapse(value) {
      this.collapseValues = value;
    },
    handleLgin() {
      this.$emit('login')
    },
    async handleRelationBind() {
      const { companyId: distributorCompanyId } = this.$store.getters.userInfo;
      let supplierCompanyId = get(this.$route, 'query.supplierId', '');
      let res = await relationBind({
        distributorCompanyId,
        needAudit: 1,
        supplierCompanyId,
      })
      if (res.result === 1) {
        this.$message.success('已提交申请')
      }
    },
    // 邀请供销商
    handleInviteSuppliers() {
      this.inviteSuppliersDialog = true;
    },
    // 邀请分销商
    handleInviteDistribute() {
      this.$refs.inviteDistribute.method_open()
    },
    /**
     * 判断是否为空值
     * @param {*} obj 
     * @returns 
     */
      JudgeEmptyKey (v) {
        return !(_.isNull(v) || _.isUndefined(v) || (_.isObjectLike(v) && _.isEmpty(v)));
    }
  },
  mounted() {
    setTimeout(() => {
      let query = this.$route.query;
      if(query && query.isOpenEditCard == 1){
        this.editCard();
      }
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 8px;
  height: 8px;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  opacity: 0.5;
}

::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 50%;
  opacity: 1;
}
::v-deep .el-dialog__body{
  padding-bottom: 0;
}
.notice-wrapper {
  padding: 8px;
  border: 1px solid #e5e5e5;

  ::v-deep .el-divider--horizontal{
    margin: 4px 0px !important;
  }
  .notice-header {
    display: flex;
    align-items: center;
    .notice-content {
      margin: 0 10px;
      overflow: hidden;
      .marquee {
        white-space: nowrap;
        animation: marquee 30s linear infinite;
      }
    }
  }  
}
@keyframes marquee {
  from { transform: translateX(100%); }
  to { transform: translateX(-100%); }
}
.el-collapse {
  border: none;
}
.el-carousel--horizontal{
  margin-bottom: 15px;
}
div ::v-deep .el-carousel__container{
  height: 200px;
}
.el-tabs__content{
  overflow-y: auto;
}
.mar-l{
  margin-left: 5px;
}
.mar-r{
  margin-right: 5px;
}
.item-flex{
  display: flex;
//   align-items: center;
}
.el-tag{
  margin-left: 10px;
}
.num{
  font-weight: bold;
}
.el-icon-edit {
  color: #396CF3;
  padding-left: 10px;
}
.statistics-wrap{
  display: flex;
  align-items: center;
  background-color: #FAFAFA;
  margin-top: 10px;
  border-radius: 5px;
  height: 76px;
  .left-time{
    text-align: center;
    display: inline-block;
    height: 76px;
    line-height: 76px;
    background-color: #aeaeae;
    border-radius: 5px 0 0 5px;
  }
  .statistics-item{
    padding: 0 0 0 25px;
  }
  .info{
    padding: 15px 0 10px 0;
  }
  .bottom-info{
    padding-bottom: 15px;
  }
  .el-icon-arrow-right{
    color: #396CF3;
  }
}
.title{
  background-color: #f2f2f2;
  text-align: center;
  line-height: 24px;
}
.main-platfrom{
  display: flex;
  align-items: center;
}
.company-item{
  padding-top: 10px;
}
.label-info{
  display: inline-block;
  width: 70px;
  color: #999999;
  flex-shrink: 0;
}
.service-list{
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  .list-item {
    width: 26%;
    text-align: center;
    background-color: #f2f2f2;
    margin: 5px 15px 0 0;
    padding: 15px 30px;
    .num{
      font-size: 18px;
    }
  }
}
.swiper-info {
  flex-shrink: 1;
  width: 0;
  flex: 1;
  ::v-deep .el-carousel{
    width: 355px;
    text-align: center;
  }
}
.slider-detail-infomation {
  width:100%;
  overflow-x: auto;
  white-space: nowrap;
  .slider-item{
    width: 80px;
    height: 80px;
    margin-right: 20px;
    display: inline-block;
    video{
      width: 100%;
      height: 100%;
    }
    .el-image{
      width: 100%;
      height: 100%;
    }
  }
}
.empty-status {
  position: relative;
  .text {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    i{
      font-size: 40px;
    }
  }
}

@media screen and (max-width: 1500px) {
  .empty-status {
    position: relative;
    .text {
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
      i{
        font-size: 25px;
      }
    }
  }
}
.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.m-popover{
  width: calc(100% - 70px);
}
.supplier-select {
  ::v-deep .el-select .el-input .el-select__caret {
    line-height: 1!important;
  }
}

::v-deep .el-collapse-item__header{
  height: auto !important;
  line-height: auto !important;
  padding-bottom: 4px;
}
.business-collapse {
  position: relative;
  ::v-deep .is-disabled {
    h3 {
      color: #333;
    }
    .el-collapse-item__arrow {
      display: none;
    }
  }
}

// 分销商端专属布局
.custom-collapse.distributor-collapse {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  overflow: hidden;

  .collapse-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;

    .header-left {
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      margin-right: 16px;

      .header-main-label {
        font-size: 14px;
        color: #6C6C6C;
        margin-right: 8px;
        flex-shrink: 0;
      }

      .header-main-text {
        font-size: 14px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }
    }

    .collapse-toggle {
      font-size: 14px;
      color: #2695fa;
      padding: 0;
      display: flex;
      align-items: center;
      gap: 4px;
      flex-shrink: 0;
      margin-left: auto;

      i {
        font-size: 12px;
        transition: transform 0.3s;
      }
    }
  }

  .collapse-content-wrapper {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
  }

  &.is-expanded .collapse-content-wrapper {
    max-height: 2000px;
    transition: max-height 0.5s ease-in;
  }

  .collapse-content {
    padding: 0px 16px 24px;
  }
}

.distributor-view {
  .d-main-layout {
    display: flex;
    gap: 24px;
  }

  .d-left-info {
    flex: 1;
    min-width: 0;
  }

  .d-info-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;

    .d-label {
      width: 80px;
      flex-shrink: 0;
      color: #6C6C6C;
      font-size: 14px;
    }

    .d-text {
      color: #333;
      font-size: 14px;
      line-height: 1.5;
    }

    .d-platform-icons {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;

      .el-avatar {
        border-radius: 50%;
      }
    }
  }

  .d-stats-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .d-stats-label {
      width: 80px;
      flex-shrink: 0;
      color: #6C6C6C;
      font-size: 14px;
      padding-top: 8px;
    }

    .d-stats-items {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }

    .d-stat-item {
      text-align: center;
      padding-right: 30px;

      .d-stat-value {
        display: block;
        color: #396CF3;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 4px;
      }

      .d-stat-sub {
        display: block;
        color: #6C6C6C;
        font-size: 14px;
      }
    }
  }

  .d-right-gallery {
    width: 460px;
    flex-shrink: 0;

    ::v-deep .el-carousel {
      width: 100%;
      border-radius: 8px;
      overflow: hidden;
    }

    .slider-detail-infomation {
      display: flex;
      gap: 8px;
      margin-top: 8px;
      overflow-x: auto;

      .slider-item {
        width: 60px;
        height: 60px;
        flex-shrink: 0;
        cursor: pointer;
        border-radius: 4px;
        overflow: hidden;

        video, .el-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
